import type { ICreatePasswordLocale } from '../../../../../Pages/Onboard/CreatePassword/Locale/CreatePassword.locale';

const ptBR: ICreatePasswordLocale = {
  title: 'Crie sua senha do {brand}',
  subtitle: 'Sua senha deve atender aos requisitos de segurança abaixo.',
  password: {
    label: 'Nova Senha',
    placeholder: 'Digite sua nova senha',
    error: 'A senha deve atender a todos os requisitos',
  },
  confirmPassword: {
    label: 'Confirmar Senha',
    placeholder: 'Confirme sua nova senha',
    error: 'Por favor, confirme sua senha',
    mismatchError: 'As senhas não coincidem',
  },
  button: {
    createPassword: 'Criar Senha',
    creatingPassword: 'Criando Senha...',
    backToLogin: 'Voltar ao Login',
  },
  success: {
    title: 'Senha criada com sucesso!',
    message: 'Sua senha foi criada. Agora você pode fazer login em sua conta.',
  },
  requirements: {
    title: 'Requisitos da Senha:',
    minLength: 'Pelo menos 8 caracteres',
    uppercase: 'Uma letra maiúscula',
    lowercase: 'Uma letra minúscula',
    number: 'Um número',
    specialChar: 'Um caractere especial',
  },
};

export { ptBR };
